module.exports = __webpack_public_path__ + "static/media/Dashboard.3f0cd33d.png";